import { render } from 'preact';
import { App } from './ui/App.tsx';
import './styles.css';

const root = document.querySelector<HTMLDivElement>('#app');
if (!root) throw new Error('Buncha Coasters app root is missing.');
render(<App />, root);
